import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-tablet",
  "use": "icon-si-glyph-tablet-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-tablet\" id=\"icon-si-glyph-tablet\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>882</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M12.995,0.043 L4.005,0.043 C2.899,0.043 2,0.94 2,2.047 L2,13.997 C2,15.102 2.899,16 4.005,16 L12.995,16 C14.101,16 15,15.103 15,13.997 L15,2.047 C15,0.94 14.102,0.043 12.995,0.043 L12.995,0.043 Z M10.083,15.042 L6.93,15.042 L6.93,13.928 L10.083,13.928 L10.083,15.042 L10.083,15.042 Z M13,13 L4,13 L4,1.97 L13,1.97 L13,13 L13,13 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-tablet.svg
// module id = zjbM
// module chunks = 62